export const pageBuilderLivePreviewDocsUrl =
  "https://prismic.io/docs/page-builder#enable-live-previews"
export const prismicDocsUrl = "https://prismic.io/docs"

export const migrationApiDocsUrl =
  "https://prismic.io/docs/migration-api-technical-reference"
export const migrationApiTryOutUrl =
  "https://pitch.com/v/MigrationAPIBetaTryout-86ni3z"

export const userSessionTokenDocsUrl =
  "https://prismic.io/docs/custom-types-api#user-session-token-advanced"
export const permanentTokenDocsUrl =
  "https://prismic.io/docs/custom-types-api#permanent-token-recommended"
